import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
import TopCard from "./TopCard";
import TableComponent from "./Table";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import moment from "moment";
import { IoClose } from "react-icons/io5";
import { getAllPaymentHistoryforCompany } from "../../actions";
import Loading from "../../../../common/components/Loading";

const OverviewTab = ({
  payment:{
    isGetAllPaymentHistoryOfCompanyLoading,
    isSubscriptionUserDetailsLoading
  },
  auth, 
  setIsPayNowBoxOpen,
  setTabChangeValue,
  setValue,
}) => {

  useEffect(() => {
    getAllPaymentHistoryforCompany(auth.companyId);
  }, [auth.isLoading]);

    // make plan name correctly
  function capitalizeFirstLetter(string) {
    if (!string) return ""; // Check for empty or undefined string
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  // format plan amount
  function formatNumber(number) {
    return number && number.toFixed(2);
  }


  return (
    <div className={styles.container}>
      <div className={styles.contentArea}>
        <TopCard
          capitalizeFirstLetter={capitalizeFirstLetter}
          formatNumber={formatNumber}
          setTabChangeValue={setTabChangeValue}
        />
        <div className={styles.bottomContainer}>
          <h1>Payment History</h1>
          <h2>See history of your payment plan invoice</h2>
          {isGetAllPaymentHistoryOfCompanyLoading ? (
            <div className={styles.loadingContainer}>
              <Loading />
            </div>
          ) : (
            <TableComponent />
          )}
        </div>
        
      </div>
    </div>
  );
};

OverviewTab.propTypes = {
  auth: PropTypes.object.isRequired,
  payment: PropTypes.object.isRequired,
  setIsPayNowBoxOpen: PropTypes.func.isRequired,
  setTabChangeValue: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({ payment: state.paymentState, auth: state.authState });

export default connect(mapStateToProps)(
  OverviewTab
);
